import { useTranslation } from '@hbs-us/ui';
import { Users } from 'lucide-react';

/**
 * The empty state for the People & Access list — shown when the directory has no users
 * matching the current role/search filter. Token-styled, with a readable headline + body
 * (A11Y-01); the icon is decorative (`aria-hidden`).
 */

export function UsersEmptyState({ searching }: { searching: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-border border-dashed bg-card p-16 text-center">
      <Users className="size-8 text-muted-foreground" aria-hidden="true" />
      <h2 className="font-display font-semibold text-foreground text-lg">
        {searching ? t('users:empty.searchHeading') : t('users:empty.heading')}
      </h2>
      <p className="max-w-sm text-muted-foreground text-sm">
        {searching ? t('users:empty.searchBody') : t('users:empty.body')}
      </p>
    </div>
  );
}
